"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var JSXIcon = function JSXIcon(props) {
  var size = props.size,
      otherProps = _objectWithoutProperties(props, ["size"]);

  return (// -- START of generated SVG source.
    _react.default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      size: size
    }, otherProps, {
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: "10"
    }), _react.default.createElement("path", {
      d: "M9.3,10.5C7.9,9.6,7,8.1,7,6.3c0-2.8,2.2-5,5-5s5,2.2,5,5c0,0.4-0.1,0.9-0.2,1.3"
    }), _react.default.createElement("circle", {
      cx: "12",
      cy: "6.3",
      r: "2"
    }), _react.default.createElement("path", {
      d: "M15.5,11.9c0.7-0.4,1.6-0.7,2.5-0.7c2.8,0,5,2.2,5,5s-2.2,5-5,5c-0.4,0-0.9-0.1-1.3-0.2"
    }), _react.default.createElement("circle", {
      cx: "18",
      cy: "16.2",
      r: "2"
    }), _react.default.createElement("line", {
      x1: "15.5",
      y1: "11.9",
      x2: "13.2",
      y2: "7.9"
    }), _react.default.createElement("line", {
      x1: "11",
      y1: "16.2",
      x2: "16",
      y2: "16.2"
    }), _react.default.createElement("line", {
      x1: "9.3",
      y1: "10.5",
      x2: "7",
      y2: "14.5"
    }), _react.default.createElement("path", {
      d: "M11,16.2c0,2.8-2.2,5-5,5s-5-2.2-5-5c0-2.3,1.6-4.3,3.7-4.8"
    }), _react.default.createElement("circle", {
      cx: "6",
      cy: "16.2",
      r: "2"
    })) // -- END of generated content.

  );
};

JSXIcon.propTypes = {
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
JSXIcon.defaultProps = {
  size: 24
};
var _default = JSXIcon;
exports.default = _default;